import { APIClient } from './api_helper';
// Import types from stripe_types instead of stripe_helper to avoid loading Stripe library
import { SetupIntentResponse, SubscriptionPlan, CreateSubscriptionRequest, SubscriptionStatus } from './stripe_types';

const api = new APIClient();

export const billingApi = {
  // Get comprehensive billing data (company info, subscription, payments, plans)
  getBillingData: () => {
    return api.get('/billing/data');
  },

  // Get available subscription plans
  getPlans: () => {
    return api.get('/billing/plans');
  },

  // Create payment intent for immediate subscription payment
  createPaymentIntent: (priceId: string, planName?: string) => {
    return api.create('/billing/payment-intent', { priceId, planName: planName || 'Subscription Plan' });
  },

  // Confirm payment success and save data
  confirmPayment: (paymentIntentId: string, planName: string) => {
    return api.create('/billing/confirm-payment', { paymentIntentId, planName });
  },

  // Create setup intent for payment method collection
  createSetupIntent: () => {
    return api.create('/billing/setup-intent', {});
  },

  // Create subscription
  createSubscription: (subscriptionData: CreateSubscriptionRequest) => {
    return api.create('/billing/subscription', subscriptionData);
  },

  // Get current subscription status
  getSubscriptionStatus: () => {
    return api.get('/billing/subscription');
  },

  // Cancel subscription
  cancelSubscription: (subscriptionId: string) => {
    return api.delete(`/billing/subscription/${subscriptionId}`);
  },

  // Update payment method after setup intent completion
  updatePaymentMethod: (setupIntentId: string) => {
    return api.create('/billing/update-payment-method', { setupIntentId });
  },

  // Calculate plan upgrade proration
  calculatePlanUpgrade: (newPriceId: string) => {
    return api.create('/billing/calculate-upgrade', { newPriceId });
  },

  // Execute plan upgrade with proration
  upgradePlan: (newPriceId: string, newPlanName: string) => {
    return api.create('/billing/upgrade-plan', { newPriceId, newPlanName });
  },

  // Get invoice history
  getInvoiceHistory: () => {
    return api.get('/billing/invoices');
  },

  // Get subscription settings (hardCap, etc.)
  getSubscriptionSettings: () => {
    return api.get('/billing/subscription/settings');
  },

  // Update hard cap setting
  updateHardCap: (hardCap: boolean) => {
    return api.put('/billing/subscription/hard-cap', { hardCap });
  }
};